'use es6';

import { usageTrackerActions } from 'usage-tracker-redux';
import { isEqual } from 'underscore';
import { CUSTOM_MODULE_EDITOR_EVENT, CODED_FILE_EDITOR_EVENT, LAYOUT_EDITOR_EVENT, FINDER_EVENT, UPLOAD_FILE_EVENT, CHILD_THEME_EVENT, getEditorUsageEventPayload, getFinderActionEventPayload, trackFinderActionOnReceive, getCodedFileType, getAssetType, trackSidebarWidgetDnD, trackLayoutInteraction, getExtraJsonForAction, trackPublish, getScreen, getDndFileCategory } from 'DesignManagerIde/utils/usageTracker/eventUtils';
import { CUSTOM_WIDGET_REVERT, CUSTOM_WIDGET_BUFFER_UPDATE, CUSTOM_WIDGET_BUFFER_ADD_ASSET, CUSTOM_WIDGET_FIELD_CREATE_GROUP, CUSTOM_WIDGET_FIELD_EDIT, CUSTOM_WIDGET_FIELD_CREATE, CUSTOM_WIDGET_BUFFER_PUBLISH, LAYOUT_DND_INSERT_SIDEBAR_WIDGET_AND_CREATE_CELL, LAYOUT_DND_INSERT_SIDEBAR_WIDGET_IN_ROW, LAYOUT_DND_MOVE_SIDEBAR_WIDGET_AND_CREATE_ROW, LAYOUT_WIDGET_SWAP, LAYOUT_REVERT, LAYOUT_PROPERTIES_EDIT, LAYOUT_WIDGET_EDIT, LAYOUT_WIDGET_EDIT_PARAMS, LAYOUT_WIDGET_CLONE, LAYOUT_WIDGET_SPLIT, LAYOUT_WIDGET_EDIT_CUSTOM_WIDGET, WIDGET_CATALOG_CATEGORY_FILTER, LAYOUT_PUBLISH, LAYOUT_OPTIMISTIC_MUTATION_MODAL_OPEN, LAYOUT_OPTIMISTIC_MUTATION_MODAL_CANCEL, LAYOUT_OPTIMISTIC_MUTATION_MODAL_CONFIRM, LAYOUT_OPTIMISTIC_MUTATION_MODAL_VIEW_DEPENDENCY, LAYOUT_OPTIMISTIC_MUTATION_MODAL_NAVIGATE_DEPENDENCY, TEMPLATE_BUFFER_REVERT, TEMPLATE_BUFFER_PUBLISH, FINDER_FILE_COPY_PATH, FINDER_FILE_COPY_PUBLIC_URL, FINDER_FILE_CREATE_PAGE, FINDER_FILE_CREATE, FINDER_FILE_DELETE, FINDER_FILE_DUPLICATE, FINDER_FILE_DUPLICATE_READ_ONLY, FINDER_FILE_RENAME, FINDER_FILE_DUPLICATE_LAYOUT_TO_TEMPLATE, FINDER_FILE_UPLOAD, FINDER_FILE_UPLOAD_FINISHED, FINDER_FOLDER_MOVE_FILE, FINDER_FILE_SHOW_INFORMATION, FINDER_FOLDER_CREATE, FINDER_FOLDER_DELETE, FINDER_FOLDER_MOVE_FOLDER, FINDER_FOLDER_DUPLICATE, FINDER_THEMES_CREATE_RECEIVE, FINDER_THEMES_DUPLICATE_RECEIVE, FINDER_THEMES_CREATE_CHILD_RECEIVE, FINDER_FUNCTIONS_CREATE, FINDER_FUNCTIONS_DEPLOY, FINDER_ASSETS_PORTAL_COPY_RECEIVE, FINDER_BULK_PORTAL_COPY, APPLICATION_TOGGLE_FINDER, FINDER_FOLDER_TOGGLE_LOCK, CODEMIRROR_OPTIONS_UPDATE, APPLICATION_SET_ALWAYS_SHOW_FINDER_ON_START, APPLICATION_UPDATE_PREVIEWER, PREVIEW_OPTIONS_SAVE_PREVIEW_WINDOW, APPLICATION_SETTINGS_USER_JSLINTER_TOGGLE, APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_UPDATE, CODE_EDITOR_TOGGLE_COMPILED_SPLIT_SCREEN } from 'DesignData/actions/ActionTypes';
import { getCustomWidgetBufferFieldsMap } from 'DesignData/selectors/customWidgetBuffers';
import { getFolder } from 'DesignData/selectors/finder';
import { THEME } from 'DesignData/enums/FolderSubcategories';
import { OCCURRENCE, VISIBILITY, VALIDATION_REGEX, HELP_TEXT, LOCKED } from 'DesignData/enums/CustomWidgetFieldAttributes';
import * as WidgetCategories from 'DesignData/enums/WidgetCategories';
import { LAYOUT, TEMPLATE } from 'DesignData/constants/FolderAssetTypes';
import { isCellType } from 'DesignData/helpers/widgets';
import { getWidget } from 'DesignData/selectors/layoutData';
import { getLayout } from 'DesignData/selectors/layouts';
import { fetch as fetchLayout } from 'DesignData/api/Layouts';
import { fetch as fetchUnifiedLayouts } from 'DesignData/actions/UnifiedLayouts';
const {
  track
} = usageTrackerActions;
export default {
  /*
   * Custom widget editor events
   */
  [CUSTOM_WIDGET_REVERT]: getEditorUsageEventPayload(CUSTOM_MODULE_EDITOR_EVENT, 'reverted-custom-module'),
  [CUSTOM_WIDGET_BUFFER_UPDATE]: (action, state, dispatch) => {
    if (!action.changes) {
      return;
    }

    if (action.changes.css) {
      dispatch(track('customWidgetActivation', getExtraJsonForAction('updated-css')));
    } else if (action.changes.js) {
      dispatch(track('customWidgetActivation', getExtraJsonForAction('updated-js')));
    } else if (action.changes.icon) {
      dispatch(track(CUSTOM_MODULE_EDITOR_EVENT, getExtraJsonForAction('updated-icon')));
    }
  },
  [CUSTOM_WIDGET_BUFFER_ADD_ASSET]: (action, state, dispatch) => {
    if (action.asset) {
      let fileType;

      if (action.assetsType === 'cssAssets') {
        fileType = 'css';
      } else if (action.assetsType === 'jsAssets') {
        fileType = 'js';
      } else {
        const fileName = action.asset.name && action.asset.name.split('.');
        fileType = fileName[fileName.length - 1];
      }

      const extraJson = fileType ? {
        file_type: fileType.toLowerCase()
      } : {};
      dispatch(track(CUSTOM_MODULE_EDITOR_EVENT, getExtraJsonForAction('added-asset', extraJson)));
    }
  },
  [CUSTOM_WIDGET_FIELD_CREATE_GROUP]: getEditorUsageEventPayload(CUSTOM_MODULE_EDITOR_EVENT, 'created-field-group'),
  [CUSTOM_WIDGET_FIELD_EDIT]: (action, state, dispatch) => {
    if (!action.field) {
      return;
    }

    const fieldsMap = getCustomWidgetBufferFieldsMap(state, {
      customWidgetId: action.customWidgetId
    });
    const oldField = fieldsMap[action.field.id];

    if (!oldField) {
      return;
    }

    if (!isEqual(action.field[OCCURRENCE], oldField[OCCURRENCE])) {
      dispatch(track(CUSTOM_MODULE_EDITOR_EVENT, getExtraJsonForAction('updated-field-repeater-options', {
        field_type: action.field.type
      })));
    } else if (!isEqual(action.field[VISIBILITY], oldField[VISIBILITY])) {
      dispatch(track(CUSTOM_MODULE_EDITOR_EVENT, getExtraJsonForAction('updated-field-display-conditions', {
        field_type: action.field.type
      })));
    } else if (!isEqual(action.field[VALIDATION_REGEX], oldField[VALIDATION_REGEX])) {
      dispatch(track(CUSTOM_MODULE_EDITOR_EVENT, getExtraJsonForAction('updated-field-validation-regex')));
    } else if (!isEqual(action.field[HELP_TEXT], oldField[HELP_TEXT])) {
      dispatch(track(CUSTOM_MODULE_EDITOR_EVENT, getExtraJsonForAction('updated-help-text')));
    } else if (action.field[LOCKED] && !oldField[LOCKED]) {
      dispatch(track(CUSTOM_MODULE_EDITOR_EVENT, getExtraJsonForAction('locked-field')));
    }
  },
  [CUSTOM_WIDGET_FIELD_CREATE]: (action, state, dispatch) => {
    if (action.field) {
      dispatch(track(CUSTOM_MODULE_EDITOR_EVENT, getExtraJsonForAction('created-field', {
        field_type: action.field.type
      })));
    }
  },
  [CUSTOM_WIDGET_BUFFER_PUBLISH]: (action, state, dispatch) => {
    if (action.customWidget) {
      // ********** PUBLIC EVENT **********
      // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
      // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
      // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
      dispatch(trackPublish('custom-design-module'));
    }
  },

  /*
   * Layout editor events
   */
  [LAYOUT_DND_INSERT_SIDEBAR_WIDGET_IN_ROW]: trackSidebarWidgetDnD('insert-in-row'),
  [LAYOUT_DND_INSERT_SIDEBAR_WIDGET_AND_CREATE_CELL]: trackSidebarWidgetDnD('insert-and-create-cell'),
  [LAYOUT_DND_MOVE_SIDEBAR_WIDGET_AND_CREATE_ROW]: trackSidebarWidgetDnD('move-and-create-row'),
  [LAYOUT_WIDGET_SWAP]: trackLayoutInteraction('swapped-module'),
  [LAYOUT_REVERT]: getEditorUsageEventPayload(LAYOUT_EDITOR_EVENT, 'reverted-dnd'),
  [LAYOUT_PROPERTIES_EDIT]: (action, state, dispatch) => {
    if (!action.edits) {
      return;
    }

    Object.keys(action.edits).forEach(layoutField => {
      switch (layoutField) {
        case 'customHead':
          dispatch(trackLayoutInteraction('edit-head-markup'));
          break;

        case 'customFooter':
          dispatch(trackLayoutInteraction('edit-footer-markup'));
          break;

        case 'bodyClass':
          dispatch(trackLayoutInteraction('edit-body-css-class'));
          break;

        case 'bodyCss':
          dispatch(trackLayoutInteraction('edit-body-css-style'));
          break;

        case 'attachedStylesheets':
          dispatch(trackLayoutInteraction('edit-attached-stylesheets'));
          break;

        case 'attachedJs':
          dispatch(trackLayoutInteraction('edit-attached-javascripts'));
          break;

        default:
          break;
      }
    });
  },
  [LAYOUT_WIDGET_EDIT]: (action, state, dispatch) => {
    if (!action.edits) {
      return;
    }

    Object.keys(action.edits).forEach(widgetField => {
      switch (widgetField) {
        case 'label':
          dispatch(trackLayoutInteraction('edit-module-label'));
          break;

        default:
          break;
      }
    });
  },
  [LAYOUT_WIDGET_EDIT_PARAMS]: (action, state, dispatch) => {
    if (!action.edits) {
      return;
    }

    const {
      edits
    } = action;
    Object.keys(edits).forEach(paramsField => {
      switch (paramsField) {
        case 'css_class':
          dispatch(trackLayoutInteraction('edit-module-css-class'));
          break;

        case 'css_style':
          dispatch(trackLayoutInteraction('edit-module-css-style'));
          break;

        case 'css_id':
          dispatch(trackLayoutInteraction('edit-module-css-id'));
          break;

        case 'css_color':
          dispatch(trackLayoutInteraction('edit-module-css-color'));
          break;

        case 'css_background_color':
          dispatch(trackLayoutInteraction('edit-module-css-background-color'));
          break;

        case 'css_border_color':
          dispatch(trackLayoutInteraction('edit-module-css-border-color'));
          break;

        case 'css_border_width':
          dispatch(trackLayoutInteraction('edit-module-css-border-width'));
          break;

        case 'css_padding_top':
        case 'css_padding_right':
        case 'css_padding_bottom':
        case 'css_padding_left':
          dispatch(trackLayoutInteraction('edit-module-css-padding'));
          break;

        case 'css_margin_top':
        case 'css_margin_right':
        case 'css_margin_bottom':
        case 'css_margin_left':
          dispatch(trackLayoutInteraction('edit-module-css-margin'));
          break;

        case 'wrapping_html':
          dispatch(trackLayoutInteraction('edit-module-wrapping-markup'));
          break;

        case 'per_widget_wrapper_html':
          dispatch(trackLayoutInteraction('edit-module-legacy-wrapping-markup'));
          break;

        case 'overrideable':
          if (edits.overrideable) {
            dispatch(trackLayoutInteraction('unlocked-module'));
          } else {
            dispatch(trackLayoutInteraction('locked-module'));
          }

          break;

        default:
          break;
      }
    });
  },
  [LAYOUT_WIDGET_CLONE]: (action, state, dispatch) => {
    const widget = getWidget(state, action);

    if (!widget) {
      return;
    }

    if (isCellType(widget.type)) {
      dispatch(trackLayoutInteraction('clone-module-group'));
    } else {
      dispatch(trackLayoutInteraction('clone-module'));
    }
  },
  [LAYOUT_WIDGET_SPLIT]: trackLayoutInteraction('split-module'),
  [LAYOUT_WIDGET_EDIT_CUSTOM_WIDGET]: (action, state, dispatch) => {
    if (action.customWidget && action.customWidget.default) {
      dispatch(trackLayoutInteraction('edit-module-cmv2-default-source'));
    } else {
      dispatch(trackLayoutInteraction('edit-module-cmv2-source'));
    }
  },
  [WIDGET_CATALOG_CATEGORY_FILTER]: (action, state, dispatch) => {
    const {
      category
    } = action;
    dispatch(trackLayoutInteraction('module-catalog-filter-by-category', {
      category: WidgetCategories[category] || 'ALL'
    }));
  },
  [LAYOUT_PUBLISH]: (action, state, dispatch) => {
    if (action.layout) {
      // ********** PUBLIC EVENT **********
      // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
      // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
      // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
      dispatch(trackPublish(getDndFileCategory(action)));
    }
  },

  /*
   * Layout - Content Overridden Modal
   */
  [LAYOUT_OPTIMISTIC_MUTATION_MODAL_OPEN]: (action, state, dispatch) => {
    dispatch(track('layoutContentOverriddenModal'));
  },
  [LAYOUT_OPTIMISTIC_MUTATION_MODAL_CANCEL]: (action, state, dispatch) => {
    dispatch(track('layoutContentOverriddenUsage', getExtraJsonForAction('cancel-changes')));
  },
  [LAYOUT_OPTIMISTIC_MUTATION_MODAL_CONFIRM]: (action, state, dispatch) => {
    dispatch(track('layoutContentOverriddenUsage', getExtraJsonForAction('confirm-changes')));
  },
  [LAYOUT_OPTIMISTIC_MUTATION_MODAL_VIEW_DEPENDENCY]: (action, state, dispatch) => {
    dispatch(track('layoutContentOverriddenUsage', getExtraJsonForAction('display-dependency')));
  },
  [LAYOUT_OPTIMISTIC_MUTATION_MODAL_NAVIGATE_DEPENDENCY]: (action, state, dispatch) => {
    dispatch(track('layoutContentOverriddenUsage', getExtraJsonForAction('navigate-dependency')));
  },

  /*
   * Code editor events
   */
  [TEMPLATE_BUFFER_REVERT]: getEditorUsageEventPayload(CODED_FILE_EDITOR_EVENT, 'reverted-coded-file'),
  [TEMPLATE_BUFFER_PUBLISH]: (action, state, dispatch) => {
    if (action.template) {
      const fileType = getCodedFileType(action); // ********** PUBLIC EVENT **********
      // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
      // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
      // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation

      dispatch(trackPublish(`coded-file-${fileType}`));
    }
  },

  /*
   * Finder events
   */
  [FINDER_FILE_COPY_PATH]: (action, state, dispatch) => {
    const {
      path
    } = action;
    if (!path) return;
    dispatch(track(FINDER_EVENT, getExtraJsonForAction('copy-path', {
      path
    })));
  },
  [FINDER_FILE_COPY_PUBLIC_URL]: (action, state, dispatch) => {
    const {
      path
    } = action;
    if (!path) return;
    dispatch(track(FINDER_EVENT, getExtraJsonForAction('copy-public-url', {
      path
    })));
  },
  [FINDER_FILE_CREATE_PAGE]: (action, state, dispatch) => {
    const {
      assetId,
      fileType
    } = action;

    switch (fileType) {
      case LAYOUT:
        {
          const layout = getLayout(state, {
            assetId
          });

          if (layout) {
            dispatch(track('createPage', {
              marketplace: Boolean(layout.marketplaceGoodId)
            }));
          } else {
            fetchLayout(assetId).then(fetchedLayout => {
              if (fetchedLayout) {
                dispatch(track('createPage', {
                  marketplace: Boolean(fetchedLayout.body.marketplace_good_id)
                }));
                dispatch(fetchUnifiedLayouts.receive(assetId, fetchedLayout));
              }
            }).catch(error => {
              dispatch(fetchUnifiedLayouts.error(assetId, error));
            });
          }
        }
        break;

      case TEMPLATE:
        dispatch(track('createPage', {
          marketplace: false
        }));
        break;

      default:
    }
  },
  [FINDER_FILE_CREATE]: trackFinderActionOnReceive('created-file'),
  [FINDER_FILE_DELETE]: trackFinderActionOnReceive('deleted-file'),
  [FINDER_FILE_DUPLICATE]: trackFinderActionOnReceive('cloned-file'),
  [FINDER_FILE_DUPLICATE_READ_ONLY]: trackFinderActionOnReceive('cloned-file'),
  [FINDER_FILE_RENAME]: trackFinderActionOnReceive('renamed-file'),
  [FINDER_FILE_DUPLICATE_LAYOUT_TO_TEMPLATE]: getFinderActionEventPayload('cloned-dnd-to-html'),
  [FINDER_FILE_UPLOAD]: (action, state, dispatch) => {
    const {
      name,
      type,
      error
    } = action.file;
    dispatch(track(UPLOAD_FILE_EVENT, getExtraJsonForAction('upload-file-failure', {
      name,
      type,
      error
    })));
  },
  [FINDER_FILE_UPLOAD_FINISHED]: (action, state, dispatch) => {
    const {
      fileName,
      fullPath
    } = action;
    dispatch(track(UPLOAD_FILE_EVENT, getExtraJsonForAction('upload-file-finished', {
      name: fileName,
      path: fullPath
    })));
  },
  [FINDER_FOLDER_MOVE_FILE]: getFinderActionEventPayload('moved-file'),
  [FINDER_FILE_SHOW_INFORMATION]: getFinderActionEventPayload('show-information-file'),
  [FINDER_FOLDER_CREATE]: getFinderActionEventPayload('created-folder'),
  [FINDER_FOLDER_DELETE]: getFinderActionEventPayload('deleted-folder'),
  [FINDER_FOLDER_MOVE_FOLDER]: getFinderActionEventPayload('moved-folder'),
  [FINDER_FOLDER_DUPLICATE]: getFinderActionEventPayload('cloned-folder'),
  [FINDER_THEMES_CREATE_RECEIVE]: (action, state, dispatch) => {
    const {
      baseTheme
    } = action;

    if (!baseTheme) {
      return;
    }

    dispatch(track(FINDER_EVENT, getExtraJsonForAction('theme-create', {
      baseTheme
    })));
  },
  [FINDER_THEMES_DUPLICATE_RECEIVE]: (action, state, dispatch) => {
    const {
      theme
    } = action;

    if (!theme) {
      return;
    }

    dispatch(track(FINDER_EVENT, getExtraJsonForAction('theme-clone', {
      baseTheme: theme.path
    })));
  },
  [FINDER_THEMES_CREATE_CHILD_RECEIVE]: (action, state, dispatch) => {
    const {
      theme
    } = action;

    if (!theme) {
      return;
    }

    dispatch(track(CHILD_THEME_EVENT, getExtraJsonForAction('create-child-theme', {
      themeName: theme.name,
      themePath: theme.path,
      parentThemePath: theme.parentThemePath
    })));
  },
  [FINDER_FUNCTIONS_CREATE]: (action, state, dispatch) => {
    const {
      folder
    } = action;

    if (!folder) {
      return;
    }

    dispatch(track(FINDER_EVENT, getExtraJsonForAction('serverless-create')));
  },
  [FINDER_FUNCTIONS_DEPLOY]: (action, state, dispatch) => {
    const {
      folderPath
    } = action;

    if (!folderPath) {
      return;
    }

    dispatch(track(FINDER_EVENT, getExtraJsonForAction('serverless-deploy')));
  },
  [FINDER_ASSETS_PORTAL_COPY_RECEIVE]: getFinderActionEventPayload('asset-portal-copy'),
  [FINDER_BULK_PORTAL_COPY]: getFinderActionEventPayload('portal-copy', {
    is_bulk: true
  }),
  [APPLICATION_TOGGLE_FINDER]: getFinderActionEventPayload('toggled-finder-pane'),
  [FINDER_FOLDER_TOGGLE_LOCK]: (action, state, dispatch) => {
    const {
      folderId,
      newFolderMetadata
    } = action;

    if (!newFolderMetadata) {
      return;
    }

    const folder = getFolder(state, {
      folderId
    }) || {};
    const depth = (folder.fullPath || '').split('/').length;
    const folderName = folder.label;
    const isThemeFolder = folder.subcategory === THEME;
    dispatch(track(FINDER_EVENT, getExtraJsonForAction('toggled-locked-folder', {
      depth,
      folderName,
      isThemeFolder
    })));
  },

  /*
   * IDE settings tracking
   */
  [CODEMIRROR_OPTIONS_UPDATE]: (action, state, dispatch) => {
    const {
      options
    } = action;
    const extraJson = {
      settings: JSON.stringify(options)
    };
    dispatch(track('codemirrorSettingsSaved', extraJson));
  },
  [APPLICATION_SET_ALWAYS_SHOW_FINDER_ON_START]: (action, state, dispatch) => {
    const {
      alwaysShowFinderOnStartup
    } = action;
    dispatch(track('generalSettingsUpdated', getExtraJsonForAction('toggle-finder-on-start', {
      toggled: alwaysShowFinderOnStartup
    })));
  },
  [APPLICATION_UPDATE_PREVIEWER]: (action, state, dispatch) => {
    const {
      updatePreviewer
    } = action;
    dispatch(track('generalSettingsUpdated', getExtraJsonForAction('toggle-previewer-auto-update', {
      toggled: updatePreviewer
    })));
  },
  [PREVIEW_OPTIONS_SAVE_PREVIEW_WINDOW]: (action, state, dispatch) => {
    const assetType = state.app.activeEditor.assetType;
    dispatch(track('preview', {
      action: 'open-preview',
      'asset-type': getAssetType(assetType)
    }));
  },

  /*
   * IDE settings tracking
   * - JavaScriptLinter
   */
  [APPLICATION_SETTINGS_USER_JSLINTER_TOGGLE]: (action, state, dispatch) => {
    const {
      data: {
        isEnabled
      }
    } = action;
    dispatch(track('javascriptLinterSettings', getExtraJsonForAction('toggle-javascript-linter', {
      toggled: isEnabled
    })));
  },
  [APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_UPDATE]: (action, state, dispatch) => {
    const {
      data: {
        eslintConfig
      }
    } = action;
    dispatch(track('javascriptLinterSettings', getExtraJsonForAction('update-javascript-linter-json-config', {
      jsonConfig: eslintConfig
    })));
  },

  /*
   * Code Editor Options
   */
  [CODE_EDITOR_TOGGLE_COMPILED_SPLIT_SCREEN]: (action, state, dispatch) => {
    const {
      data: {
        isOpen
      }
    } = action;
    dispatch(track('codeEditorOptions', getExtraJsonForAction('toggle-compiled-split-screen', {
      toggled: isOpen
    })));
  },

  /*
   * React router screen tracking
   */
  ['@@router/LOCATION_CHANGE']: (action, state, dispatch) => {
    const {
      pathname
    } = action.payload;
    const screen = getScreen(pathname);
    dispatch(track('pageView', {
      screen
    }));
  }
};